import { buildCommonFilters, embedFilter } from '../sharedFilters'

const DATASET_KEY = 'operational_security'

const IN_PROJECT_LABELS = { 0: 'No', 1: 'Sí' }
const IN_PROJECT_MAPPING = JSON.stringify({
  'units.in_project': IN_PROJECT_LABELS,
  in_project: IN_PROJECT_LABELS,
})

const inProjectMapItem = item => {
  const raw = item.filter !== undefined ? item.filter : Object.values(item)[0]
  const value = raw === null || raw === undefined ? null : String(raw)
  return { value, label: IN_PROJECT_LABELS[value] || value }
}

const commonFilters = buildCommonFilters(DATASET_KEY, {
  INSTALLATION: false,
  USER: {},
  REGION: false,
  MUNICIPALITY: false,
  SECTOR: false,
  CENTER: false,
  TENANT: false,
  STATUS: { column: 'operational_security_status_catalog.description', label: 'Estatus' },
})

export default {
  key: DATASET_KEY,
  label: 'Seguridad Operativa',
  timeColumn: 'operational_security_form_answers.created_at',
  permission: { action: 'reports', subject: 'OpSecurityForms' },

  permissionFallbacks: [
    {
      permission: { action: 'read', subject: 'BauComplement' },
      forcedWhere: {
        'operational_security_form_templates.id': { operator: 'in', values: ['83'] },
      },
      lockedFilters: ['group'],
    },
  ],


  defaults: {
    field: 'operational_security_form_templates.name',
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  csvConfig: {
    columns: 'operational_security_answers.created_at,operational_security_answers.updated_at,operational_security_questions.created_at,operational_security_questions.updated_at,operational_security_form_answers.is_mailable,operational_security_form_answers.created_at,operational_security_form_answers.completed_at,operational_security_form_answers.updated_at,operational_security_form_templates.name,operational_security_form_templates.is_mailable,operational_security_form_templates.created_at,operational_security_form_templates.updated_at,operational_security_status_catalog.description,users.user,users.name,users.email,units.description,units.active,centers.name,municipalities.name,sectors.name,regions.name',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
    //timeseries: { trendline: true },
  },

  // XLSX export delegated to a backend endpoint instead of the Streamlit CSV
  // proxy. Only date-range filters are forwarded.
  apiExport: {
    endpoint: '/v1/operational-security-forms/export/export-form-answers',
    filename: 'SeguridadOperativa.xlsx',
    baseParams: { reports_widget: true },
    // apiParam → activeFilters key (or 'from' / 'to' for the time range)
    filters: {
      template: 'group',
      status: 'status',
      from: 'from',
      to: 'to',
    },
  },

  tables: {
    operational_security_answers: ["id", "id_form_answer", "id_question", "answer", "tags", "comment", "files", "created_at", "updated_at"],
    operational_security_questions: ["id", "uuid", "id_template", "question", "active", "position", "created_at", "updated_at"],
    operational_security_form_answers: ["id", "id_user", "id_unit", "id_template", "id_prefill", "id_status", "is_mailable", "reference", "data", "created_at", "completed_at", "updated_at"],
    operational_security_form_templates: ["id", "id_tenant", "id_user", "prefill_template", "requires_prefill", "name", "description", "is_mailable", "data", "created_at", "updated_at"],
    operational_security_status_catalog: [],
    units: ["id", "id_router", "description", "address_1", "address_2", "exterior_number", "suburb", "number", "postal_code", "id_country", "id_region", "id_sector", "active", "route", "plate_number", "vin", "driver", "provider", "owner", "company", "vehicle", "allow_virtual_button_alarm", "reaction_patrol", "id_alarms_levels", "active_digital_output", "needs_check", "id_municipality", "time_zone", "data", "comments", "id_category", "id_seproban", "rems", "sirh", "in_project", "created_at", "updated_at"],
    users: ["id", "id_unit", "id_maintenance_company", "image", "check_alarms", "frame_color", "id_profile", "user", "email", "password", "name", "first_name", "second_name", "config", "plate_number", "created", "updated", "active", "vpn_access", "allow_virtual_button_alarm", "allow_visual_notifications", "allowed_units_live_video_flows", "phone_number", "alarm_history_per_hours", "alarm_history_per_days", "alarm_history_by_records", "last_login", "video_wall", "active_sesion_video_wall", "id_country", "auth_two_factor_code", "auth_two_factor_time", "auth_two_factor_type", "verify_email_code", "verify_sms_code", "verify_sms", "verify_email", "online", "enabled_chat", "enabled_helpdesk"],
    sectors: ["id", "id_center", "name", "alcaldia", "provider", "created", "updated"],
    centers: ["id", "tenant_id", "name", "description", "updated", "created", "active"],
    regions: ["id", "name", "code", "country_id", "acronym", "created_at", "updated_at"],
  },

  fields: [
    { key: 'operational_security_form_templates.name', label: 'Formulario' },
    { key: 'users.name', label: 'Nombre usuario' },
    { key: 'users.id_profile', label: 'Perfil' },
    //{ key: 'units.description', label: 'Inmueble' },
    //{ key: 'units.active', label: 'Estatus' },
    { key: 'units.in_project', label: 'En proyecto', defaultParams: { mapping: IN_PROJECT_MAPPING } },
    //{ key: 'municipalities.name', label: 'Municipio' },
    //{ key: 'regions.name', label: 'Estado' },
    //{ key: 'sectors.name', label: 'Región' },
    //{ key: 'centers.name', label: 'Centro' },
    { key: 'operational_security_status_catalog.description', label: 'Estatus' },
    { key: 'operational_security_form_answers.completed_at', label: 'Fecha de completado', defaultParams: { freq: '1mo' } },
    { key: 'operational_security_form_answers.updated_at', label: 'Fecha de actualización', defaultParams: { freq: '1mo' } },
    { key: 'operational_security_answers.created_at', label: 'Fecha de creación (Respuesta)', defaultParams: { freq: '1mo' } },
    //{ key: 'operational_security_answers.updated_at', label: 'Fecha de actualización (Respuesta)', defaultParams: { freq: '1mo' } },
    { key: 'operational_security_questions.name', label: 'Preguntas' },
    { key: 'operational_security_answers.name', label: 'Respuestas' },
  ],

  filters: [
    embedFilter(DATASET_KEY, 'operational_security_form_templates.id', 'Formulario', 'group', {
      optionsOverrides: {
        by: 'operational_security_form_templates.id,operational_security_form_templates.name',
        mapItem: item => ({
          value: String(item['operational_security_form_templates.id'] || item.id),
          label: item['operational_security_form_templates.name'] || item.name || item.id,
        }),
      },
    }),
    embedFilter(DATASET_KEY, 'operational_security_questions.name', 'Pregunta', 'questions.name'),
    embedFilter(DATASET_KEY, 'operational_security_answers.name', 'Respuesta', 'answers.name'),
    ...commonFilters,
    embedFilter(DATASET_KEY, 'units.in_project', 'En proyecto', 'in_project', {
      optionsOverrides: { mapItem: inProjectMapItem },
    }),
    // {
    //   key: 'question',
    //   label: 'Preguntas del formulario',
    //   forField: 'Preguntas del formulario',
    //   filterType: 'process-form',
    //   optionsConfig: {
    //     type: 'json-keys',
    //     dataset: 'operational_security',
    //     column: 'operational_security_form_answers.data',
    //     limit: -1,
    //     where: {
    //       'operational_security_form_templates.name': {
    //         operator: 'in',
    //         values: ['Visitas Inmuebles'],
    //       },
    //     },
    //   },
    // },
    {
      key: 'completed_at',
      label: 'Fecha de completado',
      filterType: 'where-date',
      whereColumn: 'operational_security_form_answers.completed_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'question_updated_at',
      label: 'Fecha de actualización',
      filterType: 'where-date',
      whereColumn: 'operational_security_form_answers.updated_at',
      optionsConfig: { type: 'date' },
    },
  ],

  dateGrouping: {
    column: 'operational_security_form_answers.created_at',
    presets: [
      { value: '1d', label: 'Día' },
      { value: '1w', label: 'Semana' },
      { value: '1mo', label: 'Mes' },
      { value: '1y', label: 'Año' },
    ],
  },
}
